"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Lock: function() {
        return Lock;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Lock = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C9.79086 3 8 4.79086 8 7V9H16V7C16 4.79086 14.2091 3 12 3ZM18 9V7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7V9H5C3.34315 9 2 10.3431 2 12V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V12C22 10.3431 20.6569 9 19 9H18ZM17 11H7H5C4.44772 11 4 11.4477 4 12V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V12C20 11.4477 19.5523 11 19 11H17ZM12 14C12.5523 14 13 14.4477 13 15V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15C11 14.4477 11.4477 14 12 14Z",
        fill: "currentColor"
    })
}), "Lock");
const _default = Lock;
